/** Phase 5C — food/checkout surfaces use lean bootstrap (admin/vendor/pos stay on main App) */
const FOOD_SURFACE_RE = /^\/(food|checkout)(\/|$)/;
const FOOD_MAIN_APP_RE = /^\/food\/(admin|vendor|pos)(\/|$)/;

export function isFoodSurfacePath(pathname = typeof window !== "undefined" ? window.location.pathname : "/"): boolean {
  if (FOOD_MAIN_APP_RE.test(pathname)) return false;
  return FOOD_SURFACE_RE.test(pathname);
}
